// Bundle theme module
import NSTheme from './NSTheme';
import Helper from './Classes/Helper';
import Accordion from './Classes/Accordion';
import FocusHandler from './Classes/FocusHandler';
import Jump from './Classes/Jump'
import LazyLoad from './Classes/Lazyload';
import Sticky from '../../node_modules/sticky-js';
import ResponsiveTable from "./Classes/ResponsiveTable";
import Toggler from './Classes/Toggler';
import Navigation from './Classes/Navigation';
import SetTargetBlank from './Classes/SetTargetBlank';
import FootnoteSpan from './Classes/FootnoteSpan';
import Gri from './Classes/Gri';
import CountUpNumbers from './Classes/countUpNumbers';
import SubnavigationMarkup from './Classes/SubnavigationMarkup';
import SubnavigationFunctionality from './Classes/SubnavigationFunctionality';
import Video from "./Classes/Video";
import swiper from '../../node_modules/swiper';
import TableFootnotes from './Classes/TableFootnotes';

module.exports = NSTheme;

var sliderInstance = null;
var swiperInstance = null;

// Slider events?
document.addEventListener("DOMContentLoaded", function () {

  // remove lazyload from swiper images
  const swiperImages = document.querySelectorAll('.ns-slider__inner--image .ns-slider__item-img');
  swiperImages.forEach(swiperImage => {
    if (swiperImage.classList.contains('lazy')) {
      swiperImage.classList.remove('lazy');
      swiperImage.src = swiperImage.getAttribute('data-src');
    }
  });

  new TableFootnotes();

  //Helper.loadImagesInContainer('.ns-slider');
  const sliders = document.querySelectorAll('.ns-slider');
  sliders.forEach(slider => {
    // prev-next is outside of .swiper
    const prev = slider.querySelector('.ns-slider__prev')
    const next = slider.querySelector('.ns-slider__next')

    const swip = new swiper(slider.querySelector('.swiper'), {
      slidesPerView: 1,
      centeredSlides: true,
      wrapperClass: 'swiper-wrapper',
      initialSlide: 0,
      loop: true,
      loopedSlides: 20,
      navigation: {
        nextEl: ".ns-slider__next",
        prevEl: ".ns-slider__prev",
      },

      breakpoints: {
        512: {
          initialSlide: 0,
          slidesPerView: 1,
          centeredSlides: false,
        },
        1024: {
          initialSlide: 0,
          slidesPerView: 1,
          centeredSlides: true,
        }
      },
    });

    // manual click events
    prev.addEventListener('click', (e) => {
      swip.slidePrev();
    });
    next.addEventListener('click', (e) => {
      swip.slideNext();
    });
  });
});

// everything else???
(function () {
  document.addEventListener('DOMContentLoaded', () => {

    new Navigation({
      menuTogglerSelector: '.js-nav-dropdown-toggler',
      burgerSelector: '.burger',
      searchToggle: '.search-toggle',
      searchToggleContainer: '.site-search'
    });

    new Toggler({
      togglerButtonSelector: '.ns-portrait__readmore-toggle',
      togglerContainerSelector: '.ns-portait__readmore-content'
    });

    new FocusHandler();

    new Accordion({
      accordions: '.js-toggle-accordion'
    });

    new Jump({
      graphicSelector: '.ns-graphic'
    });

    new LazyLoad();

    if (Helper.isDesktop()) {
      new Sticky('.header__bottom');
    }

    new ResponsiveTable({
      tableSelector: '.ns-table-wrap table',
      tableWrapperSelector: '.ns-table-wrap',
      breakPointLg: 1200,
      breakPointMd: 768,
      breakPointSm: 480,
      colCountNoSplit: 3,
      colCountEarlyBreak: 7,
      noSplitArray: []
    });

    new SetTargetBlank({
      targetBlanks: '.js-anchor-target'
    });

    // new FootnoteSpan({
    //   footnoteSelector: 'p.ns-style-footnote'
    // });

    new Gri();

    new Video();

    new CountUpNumbers({
      numbersSelector: '.ns-keyfigures__item:not(.no-countup) .ns-keyfigures__number',
      classIn: 'is-in-viewport',
      classOut: 'is-not-in-viewport',
      langArray: ['de-DE', 'en-US'],
      decimalArray: [',', '.'],
      thousandSepArray: ['', '']
    });

    new SubnavigationMarkup({
      header: '.ns-header',
      linkClass: '.menu__item--level-1'
    });

    new SubnavigationFunctionality({});

  })
})();
